import { render, staticRenderFns } from "./TribunalesTerr.vue?vue&type=template&id=571a3341&"
import script from "./TribunalesTerr.vue?vue&type=script&lang=js&"
export * from "./TribunalesTerr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports